export var DEFAULT_SIZE_PROP = 'rg';
export var DEFAULT_TYPE_PROP = 'default';
export var DEFAULT_BACKGROUND_COLOR = 'bayBlue30';
export var DEFAULT_BORDER_RADIUS = '4px';
export var DEFAULT_COLOR = 'greys.charcoal';
export var DEFAULT_FONT_SIZE = '14px';
export var DEFAULT_FONT_WEIGHT = 'normal';
export var DEFAULT_LINE_HEIGHT = '20px';
export var DEFAULT_LETTER_SPACING = '0.57px';
export var DEFAULT_PADDING = '4px 12px';
export var DEFAULT_ICON_MARGIN = '2px 8px 0px 0px';
export var VALID_SIZE_PROPS = ['rg', 'sm', 'xs'];
export var VALID_TYPE_PROPS = ['corner', 'default', 'placeholder', 'success', 'warning'];